import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from '../actions'
import ShapeSelector from './ShapeSelector'
import ShapeMap from './ShapeMap'
import CodesList from './CodesList'
import _ from 'lodash'

export default class CreateModal extends Component {
  constructor(props) {
    super(props)
    this.handleAddCode = this.handleAddCode.bind(this)
    this.handleUpdateCode = this.handleUpdateCode.bind(this)
    this.handleDeleteCode = this.handleDeleteCode.bind(this)
  }

  handleAddCode(code) {
    this.props.onAddCode(null, code)
  }

  handleUpdateCode(code) {
    this.props.onUpdateCode(null, code)
  }

  handleDeleteCode(index) {
    this.props.onDeleteCode(null, index)
  }

  updateValue(attribute, e) {
    actions.resetValidation(e.currentTarget)
    this.props.journeyPattern[attribute] = e.target.value
    this.forceUpdate()
  }

  handleSubmit() {
    if(actions.validateFields(this.refs) == true) {
      this.props.onAddJourneyPattern(_.assign({}, this.refs, {
        shape: this.props?.journeyPattern?.shape ? { id: this.props.journeyPattern.shape.id, name: this.props.journeyPattern.shape.name, uuid: this.props.journeyPattern.shape.uuid } : undefined,
        code_values: this.props.journeyPattern?.code_values || []
       }
     ))
      this.props.onModalClose()
      $('#NewJourneyPatternModal').modal('hide')
    }
  }

  render() {
    const {
      editMode, journeyPattern, status, type,
      onModalClose, onOpenCreateModal, onSelectShape, onUnselectShape
    } = this.props
  
    if(status.isFetching == true || status.policy['journey_patterns.create'] == false || editMode == false) {
      return false
    }
    if(status.fetchSuccess == true) {
      return (
        <div>
          <div className="select_toolbox">
            <ul>
              <li className='st_action'>
                <button
                  type='button'
                  data-toggle='modal'
                  data-target='#NewJourneyPatternModal'
                  onClick={onOpenCreateModal}
                  >
                  <span className="fa fa-plus"></span>
                </button>
              </li>
            </ul>
          </div>
          <div className={ 'modal fade ' + ((type == 'create') ? 'in' : '') } id='NewJourneyPatternModal'>
            <div className='modal-container'>
              <div className='modal-dialog'>
                <div className='modal-content'>
                  <div className='modal-header'>
                    <h4 className='modal-title'>{I18n.t('journey_patterns.actions.new')}</h4>
                  </div>

                  {(type == 'create') && (
                    <form>
                      <div className='modal-body'>
                        <div className='row'>
                          <div className='col-xs-12'>
                            <div className='form-group'>
                              <label className='control-label is-required'>{I18n.attribute_name('journey_pattern', 'name')}</label>
                              <input
                                type='text'
                                ref='name'
                                className='form-control'
                                value={journeyPattern.name}
                                onChange={(e) => this.updateValue('name', e)}
                                onKeyDown={(e) => actions.resetValidation(e.currentTarget)}
                                required
                                />
                            </div>
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-xs-6'>
                            <div className='form-group'>
                              <label className='control-label'>{I18n.attribute_name('journey_pattern', 'published_name')}</label>
                              <input
                                type='text'
                                ref='published_name'
                                className='form-control'
                                value={journeyPattern.published_name}
                                onChange={(e) => this.updateValue('published_name', e)}
                                onKeyDown={(e) => actions.resetValidation(e.currentTarget)}
                                />
                            </div>
                          </div>
                          <div className='col-xs-6'>
                            <div className='form-group'>
                              <label className='control-label'>{I18n.attribute_name('journey_pattern', 'registration_number')}</label>
                              <input
                                type='text'
                                ref='registration_number'
                                className='form-control'
                                value={journeyPattern.registration_number}
                                onChange={(e) => this.updateValue('registration_number', e)}
                                onKeyDown={(e) => actions.resetValidation(e.currentTarget)}
                                />
                            </div>
                          </div>
                        </div>

                        <div className='row'>
                          <div className='col-xs-12'>
                            <div className='form-group'>
                              <label className='control-label'>{I18n.attribute_name('journey_pattern', 'shape')}</label>
                              <ShapeSelector
                                shape = {journeyPattern?.shape}
                                onSelectShape={onSelectShape}
                                onUnselectShape={onUnselectShape}
                                disabled={!editMode}
                              />
                            </div>
                          </div>
                        </div>
                        {journeyPattern?.shape?.id && (
                          <div className='row'>
                            <div className='col-xs-12 shape-map'>
                              <ShapeMap shapeId={journeyPattern.shape.id} />
                            </div>
                          </div>
                        )}
                        <div className='row'>
                          <div className='col-xs-12'>
                            <div className='subform'>
                              <div className='nested-head'>
                                <div className='wrapper'>
                                  <div>
                                    <div className='form-group'>
                                      <label className='control-label'>{I18n.t('journey_patterns.form.flexible')}</label>
                                    </div>
                                  </div>
                                  <div></div>
                                </div>
                              </div>
                              <div className='nested-fields'>
                                <div className='wrapper'>
                                  <div className='form-group'>
                                    <label className='control-label'>{I18n.attribute_name('journey_pattern', 'booking_arrangement')}</label>
                                    <select
                                      ref='booking_arrangement_id'
                                      className='form-control'
                                      disabled={!editMode}
                                      value={journeyPattern.booking_arrangement_id || ''}
                                      onChange={(e) => this.updateValue('booking_arrangement_id', e)}
                                    >
                                      <option value=''>{I18n.t('journey_patterns.form.booking_arrangement_placeholder')}</option>
                                      {
                                        window.bookingArrangements.map(ba => <option value={ba.id}>{ba.name}</option>)
                                      }
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className='row'>
                          <div className='col-xs-12'>
                            <div className='subform'>
                              <div className='nested-head'>
                                <div className='wrapper'>
                                  <div>
                                    <div className='form-group'>
                                      <label className='control-label'>{I18n.t('activerecord.attributes.journey_pattern.codes')}</label>
                                    </div>
                                  </div>
                                  <div></div>
                                </div>
                              </div>
                              <div className='nested-fields'>
                                <div className='wrapper'>
                                  <div className='form-group'>
                                    <CodesList
                                      editMode={editMode}
                                      codeValues={journeyPattern?.code_values || []}
                                      onAddCode={this.handleAddCode}
                                      onUpdateCode={this.handleUpdateCode}
                                      onDeleteCode={this.handleDeleteCode}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className='modal-footer'>
                        <button
                          className='btn btn-cancel'
                          data-dismiss='modal'
                          type='button'
                          onClick={onModalClose}
                          >
                          {I18n.t('cancel')}
                        </button>
                        <button
                          className='btn btn-default'
                          type='button'
                          onClick={this.handleSubmit.bind(this)}
                          >
                          {I18n.t('actions.submit')}
                        </button>
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      return false
    }
  }
}

CreateModal.propTypes = {
  index: PropTypes.number,
  modal: PropTypes.object.isRequired,
  status: PropTypes.object.isRequired,
  onOpenCreateModal: PropTypes.func.isRequired,
  onModalClose: PropTypes.func.isRequired,
  onAddJourneyPattern: PropTypes.func.isRequired
}
